import { Card, Col, Container, Row } from "react-bootstrap";
import { FaEye, FaLock, FaPencilAlt, FaUser } from "react-icons/fa";
import { Link } from "react-router-dom";
import EditForm from "./Accounts/EditForm";

const AccountOperator = () => {
  return (
    <>
      <Container fluid="lg" className="mt-5 pt-5">
        <Row className="margin_bottomfooter">
          <Col
            xs={12}
            className="d-flex align-items-center justify-content-between flex-wrap mb-4"
          >
            <h6 className="fs-3 fw-bold ">Developer | Manage Operator Business</h6>
            <div className="unsaved_changes text-danger"></div>
            <div className="justify-content-between">
              <button className="btn btn-info bg-blues py-2 rounded-5">
              <FaEye className="me-1" />
                View as Member
              </button>
              <Link
                to="#"
                className="btn btn-info bg-blues mx-2 py-2 rounded-5"
              >
                 <i className="fa fa-edit me-1"></i> 
                Edit Profile
              </Link>
            </div>
          </Col>
          <Col xxl={3} lg={4} className="d-none d-lg-block mb-4">
            <Card className="sidebar_account">
              <Card.Body className="nav nav-tabs flex-column nav-pills slider_accountsidebar">
                <Link to="/form" className="nav-link mb-2 active">
                  <FaUser className="me-2" />
                  Profile Settings
                </Link>
                <Link to="#" className="nav-link mb-2">
                  <FaLock className="me-2" />
                  Shared Safaris
                </Link>
                {/* <Link to="/account/blocked-member" className="nav-link mb-2">
                  <FaUserLock className="me-2" />
                  Blocked Members
                </Link> */}
              </Card.Body>
            </Card>
          </Col>

          <Col xxl={9} lg={8} className="itenary_tabs account-settings-wrapper">
            {/* <ProfileOperatorsBusiness /> */}
            <EditForm />
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default AccountOperator;
